import { useEffect, useState } from 'react';
import { authService } from '../services/api';

/**
 * Before sign-in: which institution this page's address names
 * (GET /auth/institution, backend tenancy/host.js). Null = the product alone.
 */
export function useSignInInstitution() {
  const [institution, setInstitution] = useState(null);
  useEffect(() => {
    let live = true;
    const ask = authService && authService.institution;
    if (typeof ask !== 'function') return undefined;
    Promise.resolve(ask())
      .then((r) => { if (live) setInstitution(r.data?.institution || null); })
      .catch(() => { /* offline or an older server: the product alone */ });
    return () => { live = false; };
  }, []);
  return institution;
}
